<template>
  <div class="recommend">
    <header>
      <h2>推荐资源</h2>
    </header>
    <div class="data-table">
      <Table :data="list" :columns="columns" :border="false" @on-row-click="viewDetail"></Table>
    </div>
  </div>
</template>

<script>
import ziyingImg from '@/assets/ziying_s.png'
export default {
  name: 'Recommend',
  methods: {
    viewDetail (row) {
      this.$router.push({
        path: '/GoodsDetail',
        query: {
          id: row.id
        }
      })
      // if (!getToken()) {
      //   this.isLogin = true;
      // } else {
      // this.isLogin = false;
      // }
    }
  },
  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      columns: [
        {
          title: '品名/品牌',
          key: 'categoryName',
          render: (h, params) => {
            return h('div', {
            }, [
              h('h4', {
                style: {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '180px'
                }
              }, params.row.categoryName),
              h('div', {
                style: {
                  color: '#666',
                  fontSize: '14px'
                }
              }, [h('img', {
                style: {
                  verticalAlign: 'sub',
                  marginRight: '10px'
                },
                attrs: {
                  src: ziyingImg
                }
              }), params.row.shopName])
            ])
          },
          width: 180
        },
        {
          title: '交割地',
          key: 'fullArea'
        },
        {
          title: '单价',
          key: 'saleUnitPrice',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: params.row.expired ? '#666' : '#EE4533'
                }
              }, `${params.row.saleUnitPrice ? params.row.saleUnitPrice : ''}`),
              h('span', {
                style: {
                  fontSize: '13px'
                }
              }, ` 元/${params.row.measureUnit ? params.row.measureUnit : ''}`)
            ])
          }
        },
        // {
        //   title: '趋势',
        //   render: (h, params) => {
        //     return h('div', {
        //       style: {
        //         display: params.row.compareRes ? 'block' : 'none',
        //         color: params.row.compareRes ? 'red' : 'green'
        //       }
        //     }, [
        //       h('span', {
        //         style: {
        //           fontSize: '14px'
        //         }
        //       }, `较${params.row.compareDays}前`),
        //       h('span', {
        //         style: {
        //           fontSize: '13px'
        //         }
        //       }, ` ${params.row.priceRange}%${params.row.compareRes > 0 ? '涨' : '降'}`)
        //     ])
        //   },
        //   width: 120
        // },
        {
          title: '库存',
          key: 'stockNum',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  fontSize: '18px'
                }
              }, `${params.row.stockNum ? params.row.stockNum : ''}`),
              h('span', {
                style: {
                  fontSize: '13px'
                }
              }, ` ${params.row.measureUnit ? params.row.measureUnit : ''}`)
            ])
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('Button', {
              props: {
                type: 'success'
              },
              on: {
                click: () => this.viewDetail(params.row)
              }
            }, '查看详情')
          }
        }
      ]
    }
  },
  mounted() {
    this.list.push({shopName: '333', categoryName: '112'})
  }
}
</script>

<style scoped lang="scss">
.recommend {
  width: 860px;
  height: 862px;
  overflow: hidden;
  background-color: #fff;
  padding: 20px;
  header {
    h2 {
      font-size: 20px;
      color: #EE4533;
      text-indent: 30px;
      background: url('~@/assets/tjzy.png') no-repeat 0 center;
    }
  }
}
/deep/ .ivu-table-wrapper {
  border: none;
  .ivu-table:after{
    display: none;
  }
  .ivu-table:before{
    display: none;
  }
  .ivu-table-row {
    padding: 20px 0;
  }
  th {
    border: none;
  }
  td {
    border: none;
    height: 60px!important;
    font-size: 16px!important;
  }
  .ivu-table-body {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index/recommend.vue